import React, { useEffect, useState } from 'react';

import Loading from '../../loading';
import DashboardCard from './dashboardCard';
import SummaryCardGrid from '../components/summaryCardGrid';
import SummaryCard from '../components/summaryCard';

import MarketError from '../components/marketError';
import { average, shallowEqual } from '../../../utilities/generalHelpers';
import { getDaysBetween } from '../../../utilities/dateHelpers';
import { MarketSearchOptions } from '../tabs/marketDashboard';
import useGetHomesForSale from '../hooks/useGetHomesForSale';

const HomesForSaleCard = ({ filters }) => {
    const [summaryData, setSummaryData] = useState();
    const [lastSearch, setLastSearch] = useState();
    const { doSearch, marketLoading, marketData, apiError } =
    useGetHomesForSale();

    useEffect(() => {
        const filterKeys = Object.values(MarketSearchOptions).filter(
            (key) => key !== MarketSearchOptions.DateWindow,
        );
        if (!lastSearch || !shallowEqual(lastSearch, filters, filterKeys)) {
            doSearch(filters);
            setLastSearch(filters);
        }
    }, [filters]);

    useEffect(() => {
        if (marketData.length) {
            const today = new Date();
            let daysOnMarket = [];
            let newHomes = 0;
            const lastYear = new Date().getFullYear() - 1;
            marketData.forEach((listing) => {
                const days = getDaysBetween(listing['mls_history.listing_date'], today);
                daysOnMarket.push(days);
                if (listing['mls_history.year_built'] >= lastYear) {
                    newHomes++;
                }
            });
            const summary = {
                homesForSale: marketData.length,
                avgDaysOnMarket: average(daysOnMarket),
                newHomes,
            };
            setSummaryData(summary);
        }
    }, [marketData]);

    const handleRetry = () => {
        doSearch(filters);
    };

    return (
        <DashboardCard title="Homes For Sale">
            {apiError ? (
                <MarketError onRetry={handleRetry} />
            ) : (
                <div className="d-flex justify-content-center align-items-center w-100">
                    {marketLoading || !summaryData ? (
                        <Loading />
                    ) : (
                        <SummaryCardGrid>
                            <SummaryCard
                                title="AVG Days on Market"
                                value={`${Number(summaryData.avgDaysOnMarket).toFixed(0)} Days`}
                            />
                            <SummaryCard
                                title="Number of Homes For Sale"
                                value={summaryData.homesForSale}
                            />
                            <SummaryCard
                                title="# of New Homes for Sale"
                                value={summaryData.newHomes}
                            />
                        </SummaryCardGrid>
                    )}
                </div>
            )}
        </DashboardCard>
    );
};

export default HomesForSaleCard;
